<div class="select-container" [class.disabled]="disabled">
  @if (label && showLabel) {
    <hyperkit-typography
      class="select-label"
      variant="emphasized"
      size="sm"
      color="inherit"
      >
      {{ label }}
      @if (isRequired) {
        <span class="required-asterisk">*</span>
      }
    </hyperkit-typography>
  }

  <div class="select-wrapper">
    <!-- Main select field -->
    <div
      class="select-field"
      [class.active]="state === 'active' && !disabled"
      [class.hover]="state === 'hover' && !disabled"
      [class.focused]="state === 'focused' && !disabled"
      [class.filled]="state === 'filled' && !disabled"
      [class.inactive]="state === 'inactive' || disabled"
      [class.error]="state === 'error' && !disabled"
      [class.has-chips]="selectedOptions.length > 0"
      (click)="!disabled && toggleDropdown()"
      (mouseenter)="!disabled && onMouseEnter()"
      (mouseleave)="!disabled && onMouseLeave()"
      tabindex="0"
      (keydown.enter)="!disabled && toggleDropdown()"
      (keydown.space)="!disabled && toggleDropdown()"
      >
      <div class="select-value">
        <!-- Show placeholder when nothing is selected -->
        @if (selectedOptions.length === 0) {
          <hyperkit-typography
            class="placeholder"
            variant="body"
            size="md"
            color="inherit"
            >
            {{ placeholder }}
          </hyperkit-typography>
        }

        <!-- Display chips for selected items -->
        @if (selectedOptions.length > 0) {
          <div class="chips-container">
            @for (option of visibleChips; track option) {
              <div class="chip">
                <hyperkit-tag
                  [mode]="'fill'"
                  [closable]="true"
                  [text]="option.text"
                  (tagComponentChange)="removeChip(option, $event)"
                  >
                </hyperkit-tag>
              </div>
            }
            <!-- Overflow chip -->
            @if (overflowCount > 0) {
              <div class="chip overflow-chip">
                <hyperkit-typography variant="emphasized" size="sm" color="primary">
                  +{{ overflowCount }}
                </hyperkit-typography>
              </div>
            }
          </div>
        }
      </div>

      <div class="select-arrow">
        <hyperkit-icon
          icon="chevron-down"
          color="inherit"
          size="medium"
        ></hyperkit-icon>
      </div>
    </div>
  </div>

  <!-- Dropdown options -->
  @if (isOpen && !disabled) {
    <div class="select-dropdown">
      <hyperkit-dropdown-menu [isVisible]="isOpen">
        @if (sectionHeader) {
          <hyperkit-dropdown-menu-section-header
            [label]="sectionHeader"
          ></hyperkit-dropdown-menu-section-header>
        }
        @for (option of internalOptions; track option) {
          <hyperkit-dropdown-menu-item
            [label]="option.text"
            [selected]="isOptionSelected(option)"
            (click)="toggleOption(option, $event)"
            (keydown.enter)="toggleOption(option)"
            (keydown.space)="toggleOption(option)"
            >
            <!-- You could add a checkbox icon here to indicate multiselect -->
            @if (isOptionSelected(option)) {
              <hyperkit-icon
                icon="check"
                size="small"
                slot="prefix"
                color="inherit"
                >
              </hyperkit-icon>
            }
          </hyperkit-dropdown-menu-item>
        }
      </hyperkit-dropdown-menu>
    </div>
  }
</div>
